"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalContent_1 = require("./ModalContent");
exports.default = ModalContent_1.default;
//# sourceMappingURL=index.js.map